export const Modulos = {
  Pessoal: "pessoal",
  Rh: "rh",
  Financeiro: "financeiro"
} 